(function() {

    'use strict';

    angular.module('itxApp.common')
        .component('lazyCmpBundle', {
            bindings: { 
                products: '<',
                home: '<'
            },
            templateUrl: 'shop-the-look.component.html',
            controller: lazyCmpBundleCtrl
          });

    lazyCmpBundleCtrl.$inject = [ 
        '$timeout',
        'ItxShopCartFct',
        'ItxScreenSizeSvc',
        'HomeAnalitics'
    ];

    function lazyCmpBundleCtrl( 
        $timeout,
        ItxShopCartFct,
        ItxScreenSizeSvc,
        HomeAnalitics
    ) {

		var _this = this;
        _this.productAdded = false;
		_this.isMobile = ItxScreenSizeSvc.is('xs,sm');
		_this.useSwiper = false;
		
        _this.$onInit = function() {
            _this.productSelected = _this.products[0];
            _this.isOpenForSale = joyr.catalog.utils.isOpenForSale();
			if(_this.products.length > 4) {
				_this.useSwiper = true;
				_this.initSwiper();
			}
        };
        _this.selectProduct = function (product) {
            _this.productSelected = product;
            HomeAnalitics.selectBundleProduct(product);
        };            
        _this.onSelectedSize = function (obj) {
            _this.statusItem = '';
            _this.productSelected.selectSize(obj.size);
            HomeAnalitics.eventSelectSize(_this.productSelected, obj.size);
        };        
        
        _this.addToCart = function(product) {
            _this.addToCartClicked = true;
            if(!_this.loadAddProduct && !_this.productAdded){
                
                if( product && 
                    product.state.selectedSize && 
                    product.state.selectedColor && 
                    product.state.selectedSize.visibility == 'show'){
                    //ProductRelatedSvc.openPopupRelateds( product);
    
                    _this.loadAddProduct = true;
    
                    ItxShopCartFct.addToCart(
                        product,
                        product.state.selectedColor,
                        product.state.selectedSize,
                        null)
                    .then(function () {
                        $timeout(function () {
                            _this.productAdded = true;
                            _this.loadAddProduct = false;
                        }, 1000);
                    })
                    .catch(function() {
                        _this.productAddError = true;
                        _this.loadAddProduct = false;
                    })
                    .finally(function() {
                        $timeout(function () {
                            _this.productAdded = false;
                            _this.addToCartClicked = false;
                        }, 3000);
                    });
    
                } else {
                    _this.statusItem = 'help-error-size';
                }
            } 
          };

        _this.openSelectedProductBlank = function () {
            var urlProduct = _this.productSelected.getUrl();
            window.open(urlProduct, '_blank');

            HomeAnalitics.createProductEvent('lazyCmpBundle', _this.productSelected);
            
		};
		
		_this.initSwiper = function() {
          var slidesPerView = 4;
          if(this.isMobile) {
            slidesPerView = 3;
          }

          $timeout(function() {
              _this.swiperObj = new Swiper('.swiper-container-look', { //jshint ignore:line
                  speed: 250,
                  slidesPerView: slidesPerView,
                  observer: true,
                  spaceBetween: 8,
                  navigation: {
                      nextEl: '.ma-swiper-button-next-look',
                      prevEl: '.ma-swiper-button-prev-look',
                  },
                  pagination: {
                      el: '.swiper-pagination-look',
                      type: 'bullets',
                      clickable: true
                  }
              });
          }, 1);  
        };
        
    }

})();